import React, {useContext, useEffect, useState} from 'react';

import {first} from 'lodash';

import SelectPublicABCB from 'components/Forms/Selects/SelectPublicABCB';
import Tabs from 'components/Navigation/Tabs';
import {AuthContext} from 'contexts/AuthContext';
import {useViewport} from 'contexts/ViewportContext';
import LoginDefaultModal from 'views/login/LoginDefaultModal';
import {VIEWPORT_WIDTHS, COMPANY_STATUSES} from 'configs';

import CBAccreditationScopeStandardSchemes from './CBAccreditationScopeStandardSchemes';
import CBAccreditationScopeTechnicalSectors from './CBAccreditationScopeTechnicalSectors';
import CBAccreditationScopeKeyLocations from './CBAccreditationScopeKeyLocations';
import CBAccreditationScopeEconomy from './CBAccreditationScopeEconomy';

import styles from '../styles.module.scss';

import cx from 'classnames';
import {get} from 'lodash';

function CBAccreditationScope() {
  const {isAuth, isMainAccount, account} = useContext(AuthContext);
  const isCompanySuspended =
    get(account, 'account.company.company_status') ===
    COMPANY_STATUSES.suspended;
  const {size} = useViewport();

  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS.xl;

  const [isOpen, setIsOpen] = useState(false);
  const [selectedAB, setSelectedAB] = useState('');

  const toggle = () => setIsOpen(!isOpen);
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const modalProps = {
    isOpen,
    toggle,
  };

  // When user logged in
  useEffect(() => {
    if (isAuth) setIsOpen(false);
  }, [isAuth]);

  const tabs = [
    {
      key: 'standards',
      tabName: 'Standards and Schemes',
      children: <CBAccreditationScopeStandardSchemes selectedAB={selectedAB} />,
    },
    {
      key: 'sectors',
      tabName: 'Technical Sectors',
      children: (
        <CBAccreditationScopeTechnicalSectors selectedAB={selectedAB} />
      ),
    },
    {
      key: 'locations',
      tabName: 'Key Locations',
      children: <CBAccreditationScopeKeyLocations selectedAB={selectedAB} />,
    },
    {
      key: 'economy',
      tabName: 'Country / Economy',
      children: <CBAccreditationScopeEconomy selectedAB={selectedAB} />,
    },
  ].filter((v) => v);

  const [activeTab, setActiveTab] = useState(!!tabs ? first(tabs).key : '');

  useEffect(() => {
    setActiveTab(!!tabs ? first(tabs).key : '');
  }, [selectedAB]);

  return (
    <section
      className={cx(styles['cb-accreditation-scope'], {
        'mb-5': isAuth && isMainAccount ? !isCompanySuspended : false,
      })}
    >
      <h3 className={styles['section__title']}>Accreditation Scope</h3>
      <p className="mt-2">
        View the full scope accredited per Accreditation Body
      </p>

      {/* AB Scope Options */}
      <div className="my-4">
        <SelectPublicABCB
          className={!isMobile && 'w-50'}
          selected={selectedAB}
          isAuth={isAuth}
          toggle={toggle}
          onChange={setSelectedAB}
        />
        <p className="mt-2 text-secondary">Selected Accreditation Body</p>
      </div>

      {/* AB Scope Content */}
      <Tabs
        active={activeTab}
        toggle={toggleTab}
        tabs={tabs}
        disabled={!selectedAB}
        navClassname="mb-4"
        tabClassname="mb-4"
      />

      <LoginDefaultModal {...modalProps} redirect={false} />
    </section>
  );
}

export default CBAccreditationScope;
